import { render, staticRenderFns } from "./mainGoods.vue?vue&type=template&id=18d48b34&scoped=true&"
import script from "./mainGoods.vue?vue&type=script&lang=js&"
export * from "./mainGoods.vue?vue&type=script&lang=js&"
import style0 from "./mainGoods.vue?vue&type=style&index=0&id=18d48b34&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18d48b34",
  null
  
)

export default component.exports